/**
 * A static helper class to provide text based variables for function names.
 */
export class COMMON_FUNCTION_NAME {
  // #region Properties (32)
  static COMMON_ATTACHMENT_GET = "common-attachment-get";
  static COMMON_ATTACHMENT_GETALL = "common-attachment-getAll";
  static COMMON_ATTACHMENT_GETKEYS = "common-attachment-getKeys";
  static COMMON_ATTACHMENT_INSERT = "common-attachment-insert";
  static COMMON_ATTACHMENT_REMOVE = "common-attachment-remove";
  static COMMON_ATTACHMENT_UPDATE = "common-attachment-update";
  static COMMON_ATTACHMENT_MERGE = "common-attachment-merge";
  static COMMON_COMMENT_GET = "common-comment-get";
  static COMMON_COMMENT_GETKEYS = "common-comment-getKeys";
  static COMMON_COMMENT_GETALL = "common-comment-getAll";
  static COMMON_COMMENT_INSERT = "common-comment-insert";
  static COMMON_COMMENT_REMOVE = "common-comment-remove";
  static COMMON_COMMENT_UPDATE = "common-comment-update";
  static COMMON_COMMENT_MERGE = "common-comment-merge";
  static COMMON_REFERENCE_GET = "common-reference-get";
  static COMMON_REFERENCE_GETKETS = "common-reference-getKeys";
  static COMMON_REFERENCE_GETALL = "common-reference-getAll";
  static COMMON_REFERENCE_INSERT = "common-reference-insert";
  static COMMON_REFERENCE_REMOVE = "common-reference-remove";
  static COMMON_REFERENCE_UPDATE = "common-reference-update";
  static COMMON_REFERENCE_MERGE = "common-reference-merge";
  static CUSTOMERS_CUSTOMER_GET = "customers-customer-get";
  static CUSTOMERS_CUSTOMER_GETALL = "customers-customer-getAll";
  static CUSTOMERS_CUSTOMER_GETKEYS = "customers-customer-getKeys";
  static CUSTOMERS_CUSTOMER_INSERT = "customers-customer-insert";
  static CUSTOMERS_CUSTOMER_REMOVE = "customers-customer-remove";
  static CUSTOMERS_CUSTOMER_UPDATE = "customers-customer-update";
  static CUSTOMERS_CUSTOMER_MERGE = "customers-customer-merge";
  static FINANCIAL_BANKACCOUNT_GET = "financial-bankAccount-get";
  static FINANCIAL_BANKACCOUNT_GETKEYS = "financial-bankAccount-getKeys";
  static FINANCIAL_BANKACCOUNT_GETALL = "financial-bankAccount-getAll";
  static FINANCIAL_BANKACCOUNT_INSERT = "financial-bankAccount-insert";
  static FINANCIAL_BANKACCOUNT_REMOVE = "financial-bankAccount-remove";
  static FINANCIAL_BANKACCOUNT_UPDATE = "financial-bankAccount-update";
  static FINANCIAL_BANKACCOUNT_MERGE = "financial-bankAccount-merge";
  static FINANCIAL_BANKTRANSACTION_GET = "financial-bankTransaction-get";
  static FINANCIAL_BANKTRANSACTION_GETKEYS = "financial-bankTransaction-getKeys";
  static FINANCIAL_BANKTRANSACTION_GETALL = "financial-bankTransaction-getAll";
  static FINANCIAL_BANKTRANSACTION_INSERT = "financial-bankTransaction-insert";
  static FINANCIAL_BANKTRANSACTION_REMOVE = "financial-bankTransaction-remove";
  static FINANCIAL_BANKTRANSACTION_UPDATE = "financial-bankTransaction-update";
  static FINANCIAL_BANKTRANSACTION_MERGE = "financial-bankTransaction-merge";
  static FINANCIAL_BUDGET_GET = "financial-budget-get";
  static FINANCIAL_BUDGET_GETKEYS = "financial-budget-getKeys";
  static FINANCIAL_BUDGET_GETALL = "financial-budget-getAll";
  static FINANCIAL_BUDGET_INSERT = "financial-budget-insert";
  static FINANCIAL_BUDGET_REMOVE = "financial-budget-remove";
  static FINANCIAL_BUDGET_UPDATE = "financial-budget-update";
  static FINANCIAL_BUDGET_MERGE = "financial-budget-merge";
  static FINANCIAL_EXPENSE_GET = "financial-expense-get";
  static FINANCIAL_EXPENSE_GETKEYS = "financial-expense-getKeys";
  static FINANCIAL_EXPENSE_GETALL = "financial-expense-getAll";
  static FINANCIAL_EXPENSE_GET_UNIQUE_CATEGORIES = "financial-expense-getUniqueCategories";
  static FINANCIAL_EXPENSE_GET_UNIQUE_SUBCATEGORIES = "financial-expense-getUniqueSubCategories";
  static FINANCIAL_EXPENSE_INSERT = "financial-expense-insert";
  static FINANCIAL_EXPENSE_REMOVE = "financial-expense-remove";
  static FINANCIAL_EXPENSE_UPDATE = "financial-expense-update";
  static FINANCIAL_EXPENSE_MERGE = "financial-expense-merge";
  static FINANCIAL_EXPENSE_UPDATE_CATEGORY = "financial-expense-updateCategorization";
  static TASKS_TASK_GET = "tasks-task-get";
  static TASKS_TASK_GETKEYS = "tasks-task-getKeys";
  static TASKS_TASK_GETALL = "tasks-task-getAll";
  static TASKS_TASK_GET_WITH_SUBTASKS = "tasks-task-getWithSubTasks";
  static TASKS_TASK_INSERT = "tasks-task-insert";
  static TASKS_TASK_REMOVE = "tasks-task-remove";
  static TASKS_TASK_UPDATE = "tasks-task-update";
  static TASKS_TASK_MERGE = "tasks-task-merge";
  static PLATFORM_PERMISSION_GET = "platform-permission-get";
  static PLATFORM_PERMISSION_GETKEYS = "platform-permission-getKeys";
  static PLATFORM_PERMISSION_GETALL = "platform-permission-getAll";
  static PLATFORM_PERMISSION_INSERT = "platform-permission-insert";
  static PLATFORM_PERMISSION_REMOVE = "platform-permission-remove";
  static PLATFORM_PERMISSION_UPDATE = "platform-permission-update";
  static PLATFORM_PERMISSION_MERGE = "platform-permission-merge";
  static PLATFORM_USER_GET = "platform-user-get";
  static PLATFORM_USER_GETKEYS = "platform-user-getKeys";
  static PLATFORM_USER_GETALL = "platform-user-getAll";
  static PLATFORM_USER_INSERT = "platform-user-insert";
  static PLATFORM_USER_REMOVE = "platform-user-remove";
  static PLATFORM_USER_UPDATE = "platform-user-update";
  static PLATFORM_USER_MERGE = "platform-user-merge";
}